import axios from 'axios';
import {apiUrl} from '../index';
import {Notification} from 'components/common/uiKit';
import * as userManagement from 'services/user';

axios.defaults.baseURL = apiUrl;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, OPTIONS, PUT, PATCH, DELETE';
axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';

//axios.defaults.headers.post['Content-Type'] = 'application/json';


axios.interceptors.request.use(
    async config => {
        const user = userManagement.getUser();
        if (user && user.token) {
            config.headers.Authorization = `Bearer ${user.token}`;
        }
        return config;
    },
    error => console.log(error)
);

axios.interceptors.response.use(
    undefined,
    async (error) => {
        debugger;
        let errorResponse = undefined;
        if (error.response) {
            errorResponse = error.response;
            switch (error && error.response.status) {
                case 400:
                case 406:
                    const res = await error.response.data;
                    let messsage = '';
                    if(res && res.message)
                        messsage = res.message;
                    else if(res && res.title)
                        messsage = res.title;
                    else
                        messsage = 'UnknownException';
                    Notification('error', messsage);
                    break;
                case 401:
                    Notification('error', 'NoAuthenticate');
                    userManagement.logout();
                    break;
                case 403:
                    Notification('error', 'NoAuthorize');
                    break;
                case 404:
                    Notification('error', 'ServiceNotFound');
                    break;
                case 500:
                    debugger;
                    Notification('error', 'InternalServerError');
                    break;
            }
        } else {
            Notification('error', error.message);
        }

        return errorResponse;
    }
);

export default axios;


